<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Mes offres d'emploi
        </h1>
        <p class="text-white link-nav"><a [routerLink]="['/accueil', 'entreprise']">Accueil </a> <span
            class="lnr lnr-arrow-right"></span> <a routerLink="/mes-offres-emploi"> Mes offres d'emploi</a></p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start post Area -->
<section class="post-area section-gap">
  <div class="container">
    <!-- Search bar -->
    <div class="banner-content col-lg-12">
      <div class="serach-form-area">
        <div class="row justify-content-center form-wrap">
          <div class="col-lg-3 form-cols">
            <div class="default-select" id="default-selects2">
              <select class="nice-select" [(ngModel)]="country">
                <option value="">Pays</option>
                <option value="Benin">Bénin</option>
                <option value="Togo">Togo</option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 form-cols">
            <div class="default-select" id="default-selects2">
              <select class="nice-select" [(ngModel)]="profession">
                <option value="">Métiers/Professions</option>
                <option value="{{ profession.getId() }}" *ngFor="let profession of professionList">{{
                  profession.getLibelle() }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 form-cols">
            <div class="default-select" id="default-selects">
              <select class="nice-select" [(ngModel)]="level_of_study">
                <option value="">Niveau d'étude</option>
                <option value="Secondaire">Secondaire</option>
                <option value="Terminal">Terminal</option>
                <option value="Formation professionnelle">Formation professionnelle</option>
                <option value="Baccalauréat">Baccalauréat</option>
                <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                <option value="BAC + 2">BAC + 2</option>
                <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 form-cols">
            <div class="default-select" id="default-selects2">
              <select class="nice-select" [(ngModel)]="years_of_experience">
                <option value="">Années d'expériences</option>
                <option value="Sans experience">Sans experience</option>
                <option value="Moins d'un an">Moins d'un an</option>
                <option value="1 à 2ans">1 à 2ans</option>
                <option value="3 à 5ans">3 à 5ans</option>
                <option value="6 à 10ans">6 à 10ans</option>
                <option value="Plus de 10ans">Plus de 10ans</option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 form-cols mt-4">
            <button type="button" class="btn btn-info pt-2 pb-2" (click)="searchJob(1)">
              <span class="lnr lnr-magnifier"></span> Rechercher
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Loading -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="isLoading">
      <span style="color: red;">Chargement...</span>
    </div>
    
    <!-- Search criterea -->
    <div class="row d-flex justify-content-center">
      <div class="menu-content pb-5 pt-5 col-lg-8">
        <div class="title text-center" *ngIf="searching">
          <p style="font-weight: bold;">Recherche sur : {{ country }} | {{ getProfessionByID(profession) }} | {{
            level_of_study }} | {{ years_of_experience }}</p>
    
          <button class="btn btn-info" (click)="getJobs(1)"> Retour </button>
        </div>
      </div>
    </div>

    <!-- Nb record find -->
    <div class="row d-flex justify-content-center mb-4">
      <span style="color: green">{{ jobList.length }} enregistrement (s) trouvé(s)</span>
    </div>
    
    <!-- Pagination -->
    <div class="mb-3">
      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item disabled" *ngIf="currentPage == 1">
            <span class="page-link" tabindex="-1">Précédent</span>
          </li>
          <li class="page-item" *ngIf="currentPage > 1">
            <span class="page-link" tabindex="-1" *ngIf="!searching" (click)="getJobs(currentPage - 1)">Précédent</span>
            <span class="page-link" tabindex="-1" *ngIf="searching" (click)="searchJob(currentPage - 1)">Précédent</span>
          </li>
          <li class="page-item" *ngFor="let page of arrayOfPage">
            <span class="page-link" *ngIf="!searching" (click)="getJobs(page)">{{ page }}</span>
            <span class="page-link" *ngIf="searching" (click)="searchJob(page)">{{ page }}</span>
          </li>
          <li class="page-item disabled" *ngIf="currentPage == totalPage">
            <span class="page-link">Suivant</span>
          </li>
          <li class="page-item" *ngIf="currentPage < totalPage">
            <span class="page-link" *ngIf="!searching" (click)="getJobs(currentPage + 1)">Suivant</span>
            <span class="page-link" *ngIf="searching" (click)="searchJob(currentPage + 1)">Suivant</span>
          </li>
        </ul>
      </nav>
      <label>Page {{ currentPage }} sur {{ totalPage }}</label>
    </div>
    
    <div class="row justify-content-center d-flex" id="jobs">
      <div class="col-lg-12 post-list">
        <p style="margin-top: 100px; margin-bottom: 100px; font-size: 16px; color: red; text-align: center;"
          *ngIf="jobList.length == 0">Oups! Aucune offres trouvée</p>
    
        <app-job-card [jobList]="jobList" [typeInterface]="'entreprise'"></app-job-card>
      </div>
    </div>
    
    <!-- Pagination -->
    <div class="mt-1 mb-5">
      <label>Page {{ currentPage }} sur {{ totalPage }}</label>
      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item disabled" *ngIf="currentPage == 1">
            <span class="page-link" tabindex="-1">Précédent</span>
          </li>
          <li class="page-item" *ngIf="currentPage > 1">
            <span class="page-link" tabindex="-1" (click)="getJobs(currentPage - 1)">Précédent</span>
          </li>
          <li class="page-item" *ngFor="let page of arrayOfPage"><span class="page-link" (click)="getJobs(page)">{{ page
              }}</span></li>
          <li class="page-item disabled" *ngIf="currentPage == totalPage">
            <span class="page-link">Suivant</span>
          </li>
          <li class="page-item" *ngIf="currentPage < totalPage">
            <span class="page-link" (click)="getJobs(currentPage + 1)">Suivant</span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</section>
<!-- End post Area -->

<!-- <app-call-to-action></app-call-to-action> -->